import { render, staticRenderFns } from "./articleMarketDetail.vue?vue&type=template&id=14b02dd2&scoped=true&"
import script from "./articleMarketDetail.vue?vue&type=script&lang=js&"
export * from "./articleMarketDetail.vue?vue&type=script&lang=js&"
import style0 from "./articleMarketDetail.vue?vue&type=style&index=0&id=14b02dd2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b02dd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14b02dd2')) {
      api.createRecord('14b02dd2', component.options)
    } else {
      api.reload('14b02dd2', component.options)
    }
    module.hot.accept("./articleMarketDetail.vue?vue&type=template&id=14b02dd2&scoped=true&", function () {
      api.rerender('14b02dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/market/articleMarket/articleMarketDetail.vue"
export default component.exports